import {
  CORE_LOAD_USER_INFO_REQUEST,
  CORE_LOAD_USER_INFO_SUCCESS,

  CORE_LOAD_USERS_REQUEST,
  CORE_LOAD_USERS_SUCCESS,

  O365_LOAD_USERS_REQUEST,
  O365_LOAD_USERS_SUCCESS,

  CORE_LOAD_ALL_USERSAD_REQUEST,
  CORE_LOAD_ALL_USERSAD_SUCCESS,

  CORE_SEARCH_USERS_REQUEST,
  CORE_SEARCH_USERS_SUCCESS,


  CORE_RESET_PASSWORD_REQUEST,
  CORE_RESET_PASSWORD_SUCCESS,
} from '../../types'

const initialState = []

export default {
  users: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_USERS_REQUEST:
      case CORE_SEARCH_USERS_REQUEST:
        return []
      case CORE_LOAD_USERS_SUCCESS:
      case CORE_SEARCH_USERS_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  usersO365: (state = initialState, action) => {
    switch (action.type) {
      case O365_LOAD_USERS_REQUEST:
        return []
      case O365_LOAD_USERS_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  usersAD: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_USERSAD_REQUEST:
        return []
      case CORE_LOAD_ALL_USERSAD_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  user: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_USER_INFO_REQUEST:
        return {}
      case CORE_LOAD_USER_INFO_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  resetPassword: (state = {}, action) => {
    switch (action.type) {
      case CORE_RESET_PASSWORD_REQUEST:
        return {}
      case CORE_RESET_PASSWORD_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/user/reducer.js